/**
 * LocalStorageService
 * Centralized service for all localStorage operations
 * Provides a single source of truth for storage management
 * Eliminates circular dependencies between different layers
 */

class LocalStorageService {
  // User data keys
  setUser(userData) {
    localStorage.setItem('user', JSON.stringify(userData));
  }

  getUser() {
    const userData = localStorage.getItem('user');
    return userData ? JSON.parse(userData) : null;
  }

  removeUser() {
    localStorage.removeItem('user');
  }

  // Selected role key
  setSelectedRole(role) {
    if (role) {
      localStorage.setItem('users-selected-role', role);
      console.log('Stored selected role:', role);
    }
  }

  getSelectedRole() {
    return localStorage.getItem('users-selected-role');
  }

  removeSelectedRole() {
    localStorage.removeItem('users-selected-role');
  }

  // All roles key
  setAllRoles(roles) {
    localStorage.setItem('users-all-roles', JSON.stringify(roles));
  }

  getAllRoles() {
    const rolesStr = localStorage.getItem('users-all-roles');
    return rolesStr ? JSON.parse(rolesStr) : [];
  }

  removeAllRoles() {
    localStorage.removeItem('users-all-roles');
  }

  // Auth tokens
  setAuthToken(token) {
    localStorage.setItem('authToken', token);
  }

  getAuthToken() {
    return localStorage.getItem('authToken');
  }

  removeAuthToken() {
    localStorage.removeItem('authToken');
  }

  setRefreshToken(token) {
    localStorage.setItem('refreshToken', token);
  }

  getRefreshToken() {
    return localStorage.getItem('refreshToken');
  }

  removeRefreshToken() {
    localStorage.removeItem('refreshToken');
  }

  // Instructor data
  setInstructorData(data) {
    localStorage.setItem('instructor_data', JSON.stringify(data));
  }

  getInstructorData() {
    const data = localStorage.getItem('instructor_data');
    return data ? JSON.parse(data) : null;
  }

  removeInstructorData() {
    localStorage.removeItem('instructor_data');
  }

  // Department
  setDepartment(dept) {
    localStorage.setItem('department', dept);
  }

  getDepartment() {
    return localStorage.getItem('department');
  }

  removeDepartment() {
    localStorage.removeItem('department');
  }

  // Instructor ID
  setInstructorId(id) {
    localStorage.setItem('instructor_id', id.toString());
  }

  getInstructorId() {
    return localStorage.getItem('instructor_id');
  }

  removeInstructorId() {
    localStorage.removeItem('instructor_id');
  }

  // Clear all auth-related data at once
  clearAuthData() {
    this.removeAuthToken();
    this.removeRefreshToken();
    this.removeUser();
    this.removeSelectedRole();
    this.removeAllRoles();
    this.removeInstructorData();
    this.removeDepartment();
    this.removeInstructorId();
  }

  // Check if user is authenticated
  isAuthenticated() {
    return !!(this.getAuthToken() && this.getUser());
  }
}

// Export singleton instance
export default new LocalStorageService();
